export { WatermarkService, WatermarkConfig } from './watermark.service';
export { WatermarkDirective } from './watermark.directive';
